import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// No service worker is registered.
//
// The previous one was cache-first for every same-origin GET, /api/* included,
// with a cache name that was never bumped - so a browser that cached
// /api/orders served that copy forever and stopped seeing new orders. public/sw.js
// is now a kill switch that unregisters any worker still installed from before;
// it is deliberately still served so those browsers clean themselves up.
//
// If offline support is wanted later, use Workbox and never cache /api.
